import { apiSend, USE_MOCK_API } from './httpClient'
import { STORE_KEYS, readCollection, writeCollection } from './store'
import { addPoint, listPoints } from './points.mock'
import type { Document, TripPoint } from './types'
export interface OcrResult { text: string; candidate: {title:string|null;date:string|null;time:string|null;location:string|null}; warnings:string[]; original_url:string }
export interface ConfirmOcrInput { title:string; date:string|null; time:string|null; location:string; type:string; duration_minutes:number }
export async function recognizeDocument(tripId:string,docId:string):Promise<OcrResult> {
  if (!USE_MOCK_API) return apiSend('POST',`/trips/${tripId}/documents/${docId}/ocr`)
  const doc=readCollection<Document>(STORE_KEYS.documents).find(d=>d.id===docId&&d.trip_id===tripId)
  if (!doc) throw new Error('Document not found')
  return {text:'',candidate:{title:null,date:null,time:null,location:null},
    warnings:['Demo: enter details from the original document.'],original_url:doc.file_url}
}
export async function confirmRecognizedEvent(tripId:string,docId:string,input:ConfirmOcrInput):Promise<TripPoint> {
  if (!USE_MOCK_API) return apiSend('POST',`/trips/${tripId}/documents/${docId}/confirm`,input)
  const docs=readCollection<Document>(STORE_KEYS.documents)
  const doc=docs.find(d=>d.id===docId&&d.trip_id===tripId)
  if (!doc) throw new Error('Document not found')
  if (doc.point_id) return (await listPoints(tripId)).find(p=>p.id===doc.point_id)!
  const point=await addPoint(tripId,{title:input.title,type:input.type as TripPoint['type'],
    date:input.date,time:input.time,address:input.location,day_index:-1,
    timing:input.date&&input.time?'exact':'any',duration_minutes:input.duration_minutes})
  doc.point_id=point.id;writeCollection(STORE_KEYS.documents,docs)
  return point
}
